import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Санатории, турбазы, зоны отыха Sanatorium, camp site";

    const itemsData = [
        {
            id: 1,
            location: 'Брест',
            name: 'Санаторий-профилакторий Брестского отделения железной дороги',
            adress: 'г. Брест, ул. Карасева, 34',
            phones: [
                '(+375) 162 27-28-47',
            ],
            desc: [
                'принадлежность: Брестское отделение ж. д.',
            ],
        },
        {
            id: 2,
            location: 'Брест',
            name: 'Санаторий-профилакторий Электромеханического концерна',
            adress: 'г. Брест, ул. Советской конституции, 8/1',
            countItem: '100 мест',
            phones: [
                '(+375) 162 42-89-11',
            ],
            desc: [
                'принадлежность: Электромеханический концерн',
            ],
        },
        {
            id: 3,
            location: 'Брест',
            name: 'Санаторий-профилакторий Института повышения квалификации работников образования',
            adress: 'г. Брест, ул. Я. Купалы, 20/1',
            countItem: '130 мест',
            phones: [
                '(+375) 162 46-14-02',
            ],
            desc: [
                'принадлежность: Института повышения квалификации работников образования',
            ],
        },
        {
            id: 4,
            location: 'Брест',
            name: 'Санаторий-профилакторий Студенческий Брестского государственного технического университета',
            adress: 'г. Брест, ул. Московская, 267/1 (блок А)',
            countItem: '50 мест',
            phones: [
                '(+375) 162 42-42-31',
            ],
            desc: [
                'принадлежность: Брестский государственный технический университет',
            ],
        },
        {
            id: 5,
            location: 'Брестский район',
            name: 'Областной противотуберкулезный детский санаторий «Елочка»',
            adress: 'Брестский район, п/о Томашевка , ул. Гагарина, 10',
            countItem: '140 мест',
            desc: [
                'В 69 км от Бреста.',
                'Лечение туберкулёза',
                'Расположен в фруктовом саду и сосновом лесу, в 1 км от р. Западный Буг. Открыт в 1946. Работает круглый год. Благоприятный климат, живописная местность содействуют комплексному лечению туберкулёза. Используются специфические медикаментозные средства, лечебная физкультура, электросветолечение, диетотерапия. Сроки лечения индивидуальные. Работает школа (1 - 7-й классы).',
            ],
        },
        {
            id: 6,
            location: 'Брестский район',
            name: 'Туристско-оздоровительное унитарное предприятие «Белое озеро»',
            adress: 'Брестский район, п. Белое озеро',
            phones: [
                '(+375) 162 93 71 22',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/beoz.jpg'),
                    alt: 'Туристско-оздоровительное унитарное предприятие «Белое озеро»',
                }
            ],
            desc: [
                '«ОЗЕРО БЕЛОЕ», климато-бальнеологический курорт местного значения в Брестской области, в 25 км к югу от Бреста. Открыт в 1981.',
                'Площадь 12,6 тысяч га. Предназначен для отдыха и лечения 27 тысяч человек в год. Природные факторы (минеральные источники с хлоридно-сульфатно-бромными водами, торфяные грязи, массивы сосновых и смешанных лесов, озёра Белое и Рогознянское) благоприятствуют лечению болезней сердечно-сосудистой и нервной систем, органов дыхания нетуберкулёзного характера.',
                'Климат умеренно континентальный с сравнительно мягкой зимой. Среднегодовая температура 7,4 °С, янв. - 4,4 °С, июля 18,8°С. Относит, влажность 86 % зимой и 72 % летом. Осадков 550 мм в год. На курорте санатории «Берестье», «Верасы», турбаза «Белое озеро» и др. базы для отдыха детей и взрослых.',
            ],
        },
        {
            id: 7,
            location: 'Брестский район',
            name: 'Санаторий-профилакторий Стройтреста №8',
            adress: 'Брестский район, д. Волки',
            countItem: '100 мест',
            phones: [
                '(+375) 162 95-41-09',
            ],
            desc: [
                'принадлежность: Стройтрест №8',
            ],
        },
        {
            id: 8,
            location: 'Брестский район',
            name: 'Санаторий-профилакторий Электролампового завода',
            adress: 'Брестский район, д. Волки',
            countItem: '100 мест',
            phones: [
                '(+375) 162 95-41-06',
            ],
            desc: [
                'принадлежность: Электроламповый завод',
            ],
        },
        {
            id: 9,
            location: 'Брестский район',
            name: 'База отдыха «Белое озеро»',
            adress: 'Брестский район, п. Белое озеро',
            phones: [
                '(+375) 162 27-23-70',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/zd.jpg'),
                    alt: 'База отдыха «Белое озеро»',
                }
            ],
            desc: [
                '«БЕЛОЕ ОЗЕРО», туристская база. С 1981 входит в климато-бальнеологический курорт местного значения «Озеро Белое».',
                'Расположена на крайнем юго-западе Белоруссии, в 45 км к югу от Бреста, на одноименном озере. Открыта в 1968, функционирует круглый год, рассчитана зимой на 99, летом на 514 мест. Имеет 3-этажный корпус с 1-, 2-, 3-местными номерами со всеми удобствами и летние домики, спортивные площадки, лодочную станцию, пляж, библиотеку, киноконцертный зал, сауну. К услугам отдыхающих пункт проката туристского снаряжения и инвентаря.',
                'принадлежность: Брестское отделение Белорусской железной дороги',
            ],
        },
        {
            id: 10,
            location: 'Брестский район',
            name: 'База отдыха «Электрон» РУП «Брестэнерго»',
            adress: 'Брестский район, п. Белое озеро',
            phones: [
                '(+375) 162 93 71 77',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/energ.jpg'),
                    alt: 'База отдыха «Электрон» РУП «Брестэнерго»',
                }
            ],
            desc: [
                'принадлежность: РУП «Брестэнерго»',
            ],
        },
        {
            id: 11,
            location: 'Брестский район',
            name: 'База отдыха «Белое озеро» АО «Элма»',
            adress: 'Брестский район, п. Белое озеро',
            phones: [
                '(+375) 162 93 71 09',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/elma.jpg'),
                    alt: 'База отдыха «Белое озеро»',
                }
            ],
            desc: [
                'принадлежность: АО «Элма»',
            ],
        },
        {
            id: 12,
            location: 'Брестский район',
            name: 'Оздоровительный центр «Журавинка» ОАО «Ковры Бреста»',
            adress: 'Брестский район, д. Волки',
            countItem: '250 мест',
            phones: [
                '(+375) 162 95 41 19',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/zur.jpg'),
                    alt: 'Оздоровительный центр «Журавинка»',
                }
            ],
            desc: [
                'принадлежность: ОАО «Ковры Бреста»',
            ],
        },
        {
            id: 13,
            location: 'Брестский район',
            name: 'ДУП «Санаторий Берестье»',
            adress: 'Брестский район, п. Берестье',
            countItem: '430 мест',
            phones: [
                '(+375) 162 91-11-34',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/bereste.jpg'),
                    alt: 'ДУП «Санаторий Берестье»',
                }
            ],
            desc: [
                '«БЕРЕСТЬЕ», климато-бальнеологический санаторий. Входит в климато-бальнеологический курорт местного значения «Озеро Белое». Расположен в 45 км к югу от Бреста в хвойном лесу, на берегу оз. Рогознянского, недалеко от оз. Белого (Брестский район).',
                'Открыт в 1976, рассчитан на 470 человек. Природные факторы - благоприятный климат, живописная местность, минер, источник с хлоридно-сульфатно-бромными водами, торфяная грязь - используются для лечения сердечно-сосудистой, нервной систем, органов движения, желудочно-кишечных и гинекологических заболеваний. Санаторий оснащён соврем, медицинской аппаратурой, есть бювет, плавательный бассейн, водо- и грязелечебницы.',
            ],
        },
        {
            id: 14,
            location: 'Брестский район',
            name: 'Санаторий-профилакторий «Брестгазоаппарат»',
            adress: 'Брестский район, д. Волки',
            countItem: '58 мест',
            phones: [
                '(+375) 162 95-41-23',
            ],
            desc: [
                'принадлежность: АО «Брестгазоаппарат»',
            ],
        },
        {
            id: 15,
            location: 'Барановичи',
            name: 'Санаторий-профилакторий «Атлант» Станкостроительного завода',
            adress: 'г. Барановичи, ул. Промышленная, 32 а.',
            countItem: '',
            phones: [
                '(+375) 163 41-40-21',
                '(+375) 163 46-35-61',
                '(+375) 163 46-34-65',
            ],
            desc: [
                'принадлежность: Станкостроительный завод',
            ],
        },
        {
            id: 16,
            location: 'Барановичи',
            name: 'Санаторий-профилакторий УП «Барановичское отделение Белорусской железной дороги»',
            adress: 'г. Барановичи, ул. Гаевая, 61',
            countItem: '196 мест',
            phones: [
                '(+375) 163 47-05-95',
                '(+375) 163 49-32-98',
            ],
            desc: [
                'принадлежность: Барановичское отделение ж. д.',
            ],
        },
        {
            id: 17,
            location: 'Барановичский район',
            name: 'Туристское санаторно-оздоровительное унитарное предприятие «Лесное озеро»',
            adress: 'Барановичский район, п/о Подгородная',
            countItem: '500 мест',
            phones: [
                '(+375) 163 43-44-21',
            ],
        },
        {
            id: 18,
            location: 'Барановичский район',
            name: 'Детский лечебно-оздоровительный центр «Дружба»',
            adress: 'Барановичский район, д. Переносины',
            countItem: '',
            phones: [
                '(+375) 163 43-81-92',
            ],
        },
        {
            id: 19,
            location: 'Белоозерск',
            name: 'Санаторий-профилакторий «Брестэнерго»',
            adress: 'Березовский район, г. Белоозерск, ул. Ленина, 31',
            countItem: '100 мест',
            phones: [
                '(+375) 163 2-80-64',
                '(+375) 163 2-85-30',
                '(+375) 163 2-92-45',
            ],
            desc: [
                'принадлежность: ПО «Брестэнерго»',
            ],
        },
        {
            id: 20,
            location: 'Жабинковский район',
            name: 'Оздоровительный центр «Орленок»',
            adress: 'Жабинковский район, ур. Сосновый бор',
            countItem: '80 мест',
            phones: [
                '(+375) 1641 3-82-66',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Sanatoriums/bor.jpg'),
                    alt: 'Оздоровительный центр «Орленок»',
                }
            ],
            desc: [
                'СОСНОВЫЙ БОР, пригородная зона отдыха в 35 км к востоку от Бреста, на берегу р. Мухавец в Жабинковском районе, у автодороги Брест - Москва. Площадь свыше 2 тысяч га. Одновременно могут отдыхать более 10 тысяч человек. Профиль лечебно-оздоровительный.',
                'Лес занимает 2/3 территории, преобладают сосна и берёза. Рельеф равнинный с незначит. холмами. На территории зоны дом отдыха «Буг», санаторий-профилакторий «Сосновый бор» Брестского чулочного комбината, пионерские лагеря. Зона в стадии формирования.',
            ],
        },
        {
            id: 21,
            location: 'Жабинковский район',
            name: 'База отдыха «Сосновый бор»',
            adress: 'Жабинковский район, ур. Сосновый бор',
            desc: [
                'принадлежность: СП «Веставто»',
            ],
        },
        {
            id: 22,
            location: 'Жабинковский район',
            name: 'ДУП «Санаторий БУГ»',
            adress: 'Жабинковский район, ур. Сосновый бор',
            countItem: '536 мест',
            phones: [
                '(+375) 1641 3-81-41',
                '(+375) 1641 3-81-48',
            ],
            desc: [
                'Санаторий находится в 40 км от Бреста, 20 км от Кобрина и 14 км от города Жабинка.',
                'Из этих городов проезд автомобильным транспортом (рейсовым автобусом или маршрутным такси).',
                'Санаторий предназначен для лечения больных с заболеваниями:',
                '- органов дыхания (в т.ч. реабилитация)',
                '- сердечно-сосудистой системы (в т.ч. реабилитация)',
                'Санаторное лечение показано при хронических компенсированных расстройствах. В случае острых заболеваний, операций, поступление в санаторий возможно в восстановительном периоде и при стабильном состоянии пациента. Методы диагностики и лечения определяются врачом.',
                'Санаторий «Буг» - один из крупнейших круглогодичных санаториев Беларуси. Расположен в курортной зоне, на живописном берегу реки Мухавец.',
                'Благоустроенные корпуса, благоприятный климат, чистый сосновый воздух, уникальная целебная минеральная вода ставят санаторий «Буг» в число лучших в Республике Беларусь.',
                'Открыт в 1977 как дом отдыха, с 1982 санаторий.',
                'Сегодня это крупная комфортабельная здравница с благоустроенным бытом, который под стать европейским стандартам, популярная среди отдыхающих и известная за пределами республики.',
                'Расположен в сосновом лесу, на живописном берегу р. Мухавец. В урочище «Сосновый бор» наибольшее количество солнечный дней в году, среднегодовая температура воздуха составляет + 9 градусов С.',
            ],
        },
        {
            id: 23,
            location: 'Жабинковский район',
            name: 'Санаторий-профилакторий «Надзея»',
            adress: 'Жабинковский район, урочище Сосновый бор',
            countItem: '100 мест',
            phones: [
                '(+375) 1641 3-81-87',
                '(+375) 1641 3-81-80',
            ],
            desc: [
                'принадлежность: ПО «Брестоблгаз»',
            ],
        },
        {
            id: 24,
            location: 'Жабинковский район',
            name: 'Санаторий-профилакторий «Сосновый бор»',
            adress: 'Жабинковский район, урочище Сосновый бор',
            countItem: '100 мест',
            phones: [
                '(+375) 1641 3-81-83',
                '(+375) 1641 3-81-16',
            ],
            desc: [
                'принадлежность: «Интурист»',
            ],
        },
        {
            id: 25,
            location: 'Ивановский район',
            name: 'ДУП «Санаторий Алеся»',
            adress: '225790, Ивановский район, д. Завышье',
            countItem: '260 мест',
            phones: [
                '(+375) 1652 3-14-65',
                '(+375) 1652 3-14-29',
                '(+375) 1652 3-14-19',
            ],
        },
        {
            id: 26,
            location: 'Ивацевичский район',
            name: 'Лечебно - оздоровительное учреждение «Детский санаторий сосновый Бор»',
            adress: 'Ивацевичский район, п. Сосновый Бор',
            countItem: '125 мест',
        },
        {
            id: 27,
            location: 'Ивацевичский район',
            name: 'ДУП «Санаторий Полесье»',
            adress: 'Ивацевичский район, г.п. Телеханы',
            countItem: '182 места',
            phones: [
                '(+375) 1645 3-11-44',
                '(+375) 1645 3-14-46',
            ],
            desc: [
                'Санаторий расположен в 45 км к северу от города Ивацевичи, в 50 км к югу от города Пинска. Из этих городов автомобильным транспортом нужно проехать в городской.поселок Телеханы, где специальный автобус санатория ожидает прибывших, чтобы доставить их в санаторий.',
                'Санаторий предназначен для лечения больных с заболеваниями:',
                '- органов сердечно-сосудистой системы',
                '- нервной системы.',
                'Санаторное лечение показано при хронических компенсированных расстройствах. В случае острых заболеваний, операций, поступление в санаторий возможно в восстановительном периоде и при стабильном состоянии пациента. Методы диагностики и лечения определяются врачом',
                'Санаторий расположен в сосновом лесу. Рядом три красивых озера: Телеханское (дача П.М.Машерова), Выгоновское глубиной до 27м через которое протекает Огинский канал и Бобровичское озеро.',
            ],
        },
        {
            id: 28,
            location: 'Каменецкий район',
            name: 'ГУ «Республиканский санаторий «Белая вежа»» для ветеранов войны, труда и инвалидов',
            adress: 'Каменецкий район, п. Приозерский',
            countItem: '108 мест',
            phones: [
                '(+375) 1631 6-51-81',
            ],
        },
        {
            id: 29,
            location: 'Кобринский район',
            name: 'База отдыха «Салют»',
            adress: 'Кобринский район, д. Пески',
            phones: [
                '(+375) 1642 7-85-70',
            ],
            desc: [
                'принадлежность: БУТП «Брестгрузавтосервис»',
            ],
        },
        {
            id: 30,
            location: 'Кобрин',
            name: 'Санаторий-профилакторий «Ручайка»',
            adress: 'г. Кобрин, ул. Советская, 132/1',
            phones: [
                '(+375) 1642 2-52-88',
            ],
            desc: [
                'принадлежность: Прядильно-ткацкая фабрика «Ручайка»',
            ],
        },
        {
            id: 31,
            location: 'Лунинецкий район',
            name: 'Санаторий-профилакторий РУПП «Гранит» «Свитанок»',
            adress: '225687 Лунинецкий район, г. Микашевичи, лесопарковая зона',
            countItem: '100 мест',
            phones: [
                '(+375) 1647 2-82-77',
                '(+375) 1647 2-85-05',
            ],
            desc: [
                'принадлежность: ПО «Гранит»',
            ],
        },
        {
            id: 32,
            location: 'Лунинецкий район',
            name: 'Обласной детский ортопедический санаторий «Лахва»',
            adress: 'Лунинецкий район, д. Лахва',
            countItem: '60 мест',
        },
        {
            id: 33,
            location: 'Пинск',
            name: 'Санаторий-профилакторий «Жемчужный» ОАО промышленно-торгового объединения «Полесье»',
            adress: 'г. Пинск, ул. Слоботская, 8',
            phones: [
                '(+375) 165 34-19-73',
                '(+375) 165 34-19-49',
            ],
            desc: [
                'ночлег, питание',
                'принадлежность: ОАО промышленно-торговое объединение «Полесье»',
            ],
        },
        {
            id: 34,
            location: 'Пинск',
            name: 'Пинская городская база юных туристов',
            adress: 'г. Пинск, ул. Гайдаенка, 58',
            countItem: '',
            phones: [
                '(+375) 165 33-02-06',
                '(+375) 165 33-28-17',
            ],
        },
        {
            id: 35,
            location: 'Пинский район',
            name: 'ГУ «Республиканский санаторий «Ясельда»» для ветеранов войны, труда и ГУ «Республиканский санаторий «Ясельда»» для ветеранов войны, труда и инвалидовинвалидов',
            adress: '225737, Пинский район, п/о Кулятичи, д. Почепово',
            countItem: '75 мест',
            phones: [
                '(+375) 165 38 81 31',
                '(+375) 165 38-81-98',
                '(+375) 165 34-53-94',
            ],
        },
        {
            id: 36,
            location: 'Пинский район',
            name: 'Пинская районная база юных туристов',
            adress: 'Пинский район, д. Ставок',
            countItem: '',
            phones: [
                '(+375) 165 30-21-19',
                '(+375) 165 30-21-13',
            ],
            desc: [
                'ночлег, питание',
            ],
        },
        {
            id: 37,
            location: 'Пинский район',
            name: 'Республиканское унитарное предприятие «Детский реабилитационно-оздоровительный центр «Свитанок»»',
            adress: 'Пинский район, п/о Пагост Загородский',
            countItem: '',
            phones: [
                '(+375) 165 38-78-61',
            ],
        },
    ];

    let get_all_list = (sanData) => {
        return (
            <ul>
                {sanData?.map((h) => {
                    const link = "/reference-information-sanatoriums/" + h.id;
                    return (<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress != undefined && <p>{data.adress}</p>}
                {data.countItem != undefined && <p>{data.countItem}</p>}
                {data.phones != undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url != undefined && <a href={data.url}>{data.url}</a>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data.timeWork != undefined && <p>{data.timeWork}</p>}
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}